<template>
  <app-table
      :data="items"
      :loading="isLoading"
      highlight-rows-on-hover
  >
    <app-table-column first attribute="start" :label="translations.start">
      <template slot-scope="row">
        <div v-html="formatDate(row.start)" />
      </template>
    </app-table-column>
    <app-table-column attribute="end" :label="translations.end">
      <template slot-scope="row">
        <div v-html="formatDate(row.end)" />
      </template>
    </app-table-column>
    <app-table-column label="Info log">
      <template slot-scope="row">
        <app-button :disabled="!row.logInfoFileExists" class="btn_darkblue" @click="onInfoLogClick(row)" v-translate>
          Log
        </app-button>
        <a v-if="row.logInfoFileExists" class="download_link" :title="translations.downloadLog" @click="downloadLog(row, 'info')">{{ translations.downloadLog }}</a>
      </template>
    </app-table-column>
    <app-table-column label="Warning log">
      <template slot-scope="row">
        <app-button :disabled="!row.logWarningFileExists" class="btn_orange" @click="onWarningLogClick(row)" v-translate>
          Log
        </app-button>
        <a v-if="row.logWarningFileExists" class="download_link" :title="translations.downloadLog" @click="downloadLog(row, 'warning')">{{ translations.downloadLog }}</a>
      </template>
    </app-table-column>
    <app-table-column label="Error log">
      <template slot-scope="row">
        <app-button :disabled="!row.logErrorFileExists" @click="onErrorLogClick(row)" v-translate>
          Log
        </app-button>
        <a v-if="row.logErrorFileExists" class="download_link" :title="translations.downloadLog" @click="downloadLog(row, 'error')">{{ translations.downloadLog }}</a>
      </template>
    </app-table-column>
    <app-table-column label="Log summary">
      <template slot-scope="row">
        <app-button :disabled="!row.logSummaryFileExists" class="btn_darkblue" @click="onSummaryLogClick(row)" v-translate>
          Log
        </app-button>
        <a v-if="row.logSummaryFileExists" class="download_link" :title="translations.downloadLog" @click="downloadLog(row, 'summary')">{{ translations.downloadLog }}</a>
      </template>
    </app-table-column>
    <app-table-column attribute="status" :label="translations.status">
      <template slot-scope="row">
        {{ enumsMap.get(row.status) }}
      </template>
    </app-table-column>
    <app-table-column attribute="result" :label="translations.result">
      <template slot-scope="row">
        <img
            v-if="row.result === 'ok'"
            class="is_set"
            title="OK"
            alt="OK"
            src="../../assets/images/is-set.svg"
        >
        <img
            v-if="row.result === 'warning'"
            class="is_set"
            :title="translations.warning"
            :alt="translations.warning"
            src="../../assets/images/warning.svg"
        >
        <img
            v-if="row.result === 'error'"
            class="is_set"
            :title="translations.error"
            :alt="translations.error"
            src="../../assets/images/isnot-set.svg"
        >
      </template>
    </app-table-column>
  </app-table>
</template>

<script>
import appTitleMixin from 'mixins/appTitleMixin'
import getItemsListMixin from 'mixins/getItemsListMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { mapActions, mapState } from 'vuex'
import { VUE_APP_BASE_API_URL } from '../../constants/fileConstants'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'CronRuns',
  enumsMap: true,
  preventFetchOnCreated: true
})

export default {
  name: 'cron-runs',
  mixins: [
    itemsListMixin,
    formatDateMixin,
    appTitleMixin()
  ],
  props: {
    title: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapState({
      items: state => state.crons.cronRuns,
      itemsMetadata: state => state.crons.cronRunsMetadata,
      pending: state => state.crons.pending.cronRuns
    }),
    translations() {
      return {
        start: this.$gettext('Začátek'),
        end: this.$gettext('Konec'),
        status: this.$gettext('Status'),
        result: this.$gettext('Výsledek'),
        warning: this.$gettext('Varování'),
        error: this.$gettext('Chyba'),
        downloadLog: this.$gettext('Stáhnout log')
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Crony'), link: { name: 'crons' } },
        this.title
      ]
    },
    itemId() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.fetchItems()
  },
  methods: {
    ...mapActions([
      'getCronRuns',
      'downloadCronRunLog'
    ]),
    async fetchItems() {
      const id = this.itemId
      this.getCronRuns({ params: { id } })
    },
    onInfoLogClick(row) {
      this.goToLogFile(row, 'info')
    },
    onWarningLogClick(row) {
      this.goToLogFile(row, 'warning')
    },
    onErrorLogClick(row) {
      this.goToLogFile(row, 'error')
    },
    onSummaryLogClick(row) {
      this.goToLogFile(row, 'summary')
    },
    downloadLog(row, type) {
      this.downloadCronRunLog({
        params: {
          id: row._id,
          type: type
        }
      }).then((response) => {
        const blob = new Blob([response.data], { type: 'text/plain' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = type + '_' + row._id + '.log'
        link.click()
      })
    },
    goToLogFile(row, logType) {
      this.$router.push({
        name: 'cron-run-log',
        params: {
          id: this.$route.params.id,
          idRun: row._id,
          log: logType
        }
      })
    }
  },
  watch: {
    pending(v) {
      if (!v) {
        this.isLoading = false
      }
    }
  }
}
</script>
